import * as React from 'react'
import {Nullable} from '../../../../../app/TypeHelpers'
import {NatAbsenceContactAddress} from '../NatResidentApplicationInterface'
import NatResidentApplicationDetailConfirmItem from '../../common/resident/NatResidentApplicationDetailConfirmItem'
import {BlockSpacer} from '../../../../../styledComponents/ResponsiveConvenience'
import {getFormattedAddress} from '../helper/NatContactAddressOnEmergencyHelper'

interface Props {
    absenceContactAddress: Nullable<NatAbsenceContactAddress>
}

const NatResidentAbsenceContactAddressConfirmView = (props: Props) => {
    const {absenceContactAddress} = props

    if (!absenceContactAddress) {
        return <></>
    }

    const {
        familyName, firstName, zipCode, prefecture, address2,
        address3, buildingRoomNumber, fixedPhoneNumber, mobilePhoneNumber
    } = absenceContactAddress

    const items = []
    items.push(`氏名：${familyName} ${firstName}`)
    items.push(`住所：${getFormattedAddress(zipCode, prefecture, address2, address3, buildingRoomNumber)}`)
    items.push(`固定電話番号：${fixedPhoneNumber}`)
    items.push(`携帯電話番号：${mobilePhoneNumber}`)

    return (<>
        <NatResidentApplicationDetailConfirmItem
            title={'上記連絡先不在などの場合の連絡先'}
            items={items}
        />
        <BlockSpacer height={'5px'}/>
    </>)
}

NatResidentAbsenceContactAddressConfirmView.displayName = 'NatResidentAbsenceContactAddressConfirmView'
export default NatResidentAbsenceContactAddressConfirmView